export default import.meta.ROLLUP_FILE_URL_kSHvwCjLFxLpY3FM1MyAsA;